import gql from 'graphql-tag'

export const ADD_TICKETS_TO_CART = gql`
  mutation addTicketsToCart($input: AddTicketsToCartInput!) {
    addTicketsToCart(input: $input) {
      cart {
        id
      }
      errors {
        code
        message
      }
    }
  }
`
